import { Directive, ElementRef} from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, NgControl } from '@angular/forms';

@Directive({
    selector: 'input[ngModel],textarea[ngModel]',
    host: {
        '(ngModelChange)': 'onInputChange($event)',
        '(input)': 'onInputChange($event.target.value, true)',
        '(textarea)': 'onInputChange($event.target.value, true)'
    },
    standalone: false
})
export class SpecialCharactersDirective {
  constructor(public model: NgControl, public ele: ElementRef/*, public render: Renderer*/) { }

  onInputChange(event, backspace) {
    if (!event) return; //failsafe
    if (this.ele.nativeElement.outerHTML.toLowerCase().includes("bsdatepicker")) return;
    if (this.ele.nativeElement.type != "text" && this.ele.nativeElement.type != "textarea") return;
    var position = this.ele.nativeElement.selectionStart;
    var value = event.replace(/(?![\x08\x0A\x0D])[\u0000-\u001f\u003a]/gi, '');
    if (this.ele.nativeElement.value === value) return;
    this.ele.nativeElement.selectionEnd = position;
    this.model.valueAccessor.writeValue(value);
    this.ele.nativeElement.value = value;
  }


}
